import React, { useEffect, useState } from "react";

import "../styles/quiz-groups.scss";
import QuizGroupsOptions from "./quiz-groups-options";
import QuizGroupsQuestions from "./quiz-groups-questions";

function QuizGroups({
  questionsData,
  userDataProp,
  userStateForm,
  setCurrentQuestionsGroup,
  setCurrentOptionsGroup,
  setUserTypeForm,
  userLang,
}) {
  const [questionsDataArray, setQuestionsDataArray] = useState();
  const [options, setOptions] = useState();
  const [questions, setQuestions] = useState();
  const [userData, setUserData] = useState(userDataProp);
  const [isActiveQuestionsGroups, setIsActiveQuestionsGroups] = useState();
  const [isActiveVotingGroups, setIsActiveVotingGroups] = useState();

  useEffect(() => {
    setUserData(userDataProp);
  }, [userDataProp]);

  useEffect(() => {
    if (questionsData) {
      setQuestionsDataArray(Object.entries(questionsData));
    }
  }, [questionsData]);

  useEffect(() => {
    if (questionsDataArray) {
      questionsDataArray.map((question) => {
        if (question[0] === "questions") {
          return setQuestions(Object.values(question[1]));
        } else {
          return setOptions(Object.values(question[1]));
        }
      });
    }
  }, [questionsDataArray]);

  return (
    <div className="groups-div">
      <div className="groups-title-div">
        <h4 className="groups-title">
          {userLang === "es" ? "Grupos de preguntas" : "Questions Groups"}
        </h4>
      </div>
      <div>
        <p className="subtitle text-subtitle-2">
          {userLang === "es"
            ? "Indica la respuesta más cercana"
            : "Indicate the closest answer"}
        </p>
      </div>
      <QuizGroupsQuestions
        userData={userData}
        questions={questions}
        setCurrentQuestionsGroup={setCurrentQuestionsGroup}
        setUserTypeForm={setUserTypeForm}
        isActiveQuestionsGroups={isActiveQuestionsGroups}
        setIsActiveQuestionsGroups={setIsActiveQuestionsGroups}
        setIsActiveVotingGroups={setIsActiveVotingGroups}
        userLang={userLang}
      />
      <div className="groups-title-div">
        <h4 className="groups-title">
          {userLang === "es" ? "Grupos de votación" : "Voting groups"}
        </h4>
      </div>
      <div>
        <p className="subtitle text-subtitle-2">
          {userLang === "es"
            ? "Indica el escenario más predominante"
            : "Indicates the most predominant scenario"}
        </p>
      </div>
      <QuizGroupsOptions
        userData={userData}
        options={options}
        setCurrentOptionsGroup={setCurrentOptionsGroup}
        setUserTypeForm={setUserTypeForm}
        isActiveVotingGroups={isActiveVotingGroups}
        setIsActiveQuestionsGroups={setIsActiveQuestionsGroups}
        setIsActiveVotingGroups={setIsActiveVotingGroups}
        userLang={userLang}
      />
    </div>
  );
}

export default QuizGroups;
